angular.module('impactx.smartform').controller('SmartFormEditorCtrl', [
    '$scope',
    'SmartFormTemplateCache',
    'SmartFormService',
    'orderByFilter',
    SmartFormEditorController]);

function SmartFormEditorController($scope, SmartFormTemplateCache, SmartFormService, orderByFilter) {
    var self = this;
    var usageTypesWithOrderFields = SmartFormTemplateCache.usageTypes.ALL_BUT_SAP;
    self.showOutlines = false;
    self.showPreview = false;
    self.titleMode = false;
    self.selectedColumnAmount = 0;

    $scope.$watch(function () {
        return self.selectedColumnAmount;
    }, function (newValue, oldValue) {
        if (!angular.equals(newValue, oldValue)) {
            var index = 0;
            var repositionItems = newValue <= oldValue && checkItemExpansion(newValue);

            if ($scope.layout) {
                $scope.layout.columns = newValue;
            }
            else {
                $scope.layout = {
                    columns: newValue
                }
            }
            $scope.smartFormGridsterOptions = SmartFormTemplateCache.createSmartFormGridsterConfig({columns: newValue});

            if (repositionItems) {
                angular.forEach($scope.formEntries, function (entry) {
                    entry.layout.row = index + entry.layout.sizeY;
                    entry.layout.column = 0;
                    entry.layout.sizeX = 1;

                    index += entry.layout.sizeY + 1;
                });
            }
        }
    });

    self.toggleOutlines = function () {
        self.showOutlines = !self.showOutlines;
    };

    self.togglePreview = function () {
        if (!self.showPreview) {
            buildPreviewForm()
        }
        else {
            var smartFormIdentifier = 'preview' + $scope.identifier;
            SmartFormTemplateCache.removeForm(smartFormIdentifier);
            delete $scope.previewForm;
            delete $scope[smartFormIdentifier];
        }
        self.showPreview = !self.showPreview;
    };

    self.addComponent = function (template) {
        var component = angular.copy(template);
        component.identifier = $scope.identifier + Math.floor(Math.random() * 100);
        component.id = 0;
        component.layout.readOnly = true;
        component.layout.editable = true;
        component.layout.row = SmartFormTemplateCache.calculateRowPlacement($scope.identifier);
        SmartFormTemplateCache.insertComponent($scope.identifier, component);
    };

    self.componentAllowed = function (template) {
        if (template) {
            return template.allowedUsageTypes.indexOf($scope.usageType) > -1;
        }
    };

    self.showOrderFields = function () {
        return usageTypesWithOrderFields.indexOf($scope.usageType) > -1;
    };

    self.selectTemplateComponent = function (templateComponent) {
        var currentState = templateComponent.selected;
        angular.forEach($scope.templateComponents, function (component) {
            component.selected = false;
        });

        templateComponent.selected = !currentState;
    };

    function checkItemExpansion(newColumnSize) {
        var result = false, currentColumn = 0, currentColumnWidth = 0;
        var tmp = angular.copy(SmartFormService.convertObjectToArray($scope.formEntries));
        orderByFilter(tmp, 'column');

        angular.forEach(tmp, function (entry) {
            currentColumn = entry.layout.column;
            currentColumnWidth = currentColumn + entry.layout.sizeX;
            if (currentColumnWidth > newColumnSize) {
                result = true;
            }
        });

        return result;
    }

    function buildPreviewForm() {
        var array = SmartFormService.convertObjectToArray($scope.formEntries);

        $scope.previewForm = {
            identifier: 'preview' + $scope.identifier,
            entries: array,
            layout: $scope.layout
        }
    }
}